export const Loader = () => {
   return (
      <div className="fixed inset-0 grid h-full w-full place-items-center">
         <div className="grid place-items-center text-center">
            <svg
               width="57"
               height="57"
               viewBox="0 0 57 57"
               fill="none"
               xmlns="http://www.w3.org/2000/svg"
               className="animate-spin"
            >
               <path
                  d="M53.4375 28.5C55.405 28.5 57.0229 26.8989 56.7776 24.9467C56.321 21.3127 55.1666 17.7893 53.3661 14.5743C50.9835 10.3197 47.549 6.74763 43.3912 4.19975C39.2334 1.65187 34.4915 0.213416 29.6189 0.0219724C24.7463 -0.169471 19.9061 0.892503 15.5613 3.10632C11.2164 5.32013 7.51226 8.61172 4.80311 12.6663C2.09397 16.7208 0.470448 21.4026 0.0878556 26.2639C-0.294737 31.1252 0.576394 36.0034 2.61792 40.4318C4.1606 43.7781 6.3326 46.7831 9.00416 49.2885C10.4393 50.6344 12.6856 50.2666 13.8421 48.6749V48.6749C14.9986 47.0831 14.6192 44.8733 13.2414 43.4688C11.5276 41.7219 10.1203 39.6872 9.08844 37.4489C7.5573 34.1275 6.90395 30.4689 7.19089 26.8229C7.47784 23.177 8.69547 19.6656 10.7273 16.6247C12.7592 13.5838 15.5373 11.1151 18.796 9.45474C22.0546 7.79438 25.6847 6.9979 29.3392 7.14148C32.9936 7.28506 36.5501 8.36391 39.6684 10.2748C42.7867 12.1857 45.3626 14.8648 47.1496 18.0557C48.3539 20.2062 49.1728 22.5407 49.5788 24.9539C49.9052 26.8942 51.47 28.5 53.4375 28.5V28.5Z"
                  fill="#0136BC"
               />
            </svg>
            <div className="grid gap-2 py-4">
               <h4 className="text-sm">Loading your page...</h4>
               <p className="text-xs">
                  Processing your application with care and precision
               </p>
            </div>
         </div>
      </div>
   );
};
